module.exports = __webpack_public_path__ + "media/brands/deutz-fahr-a677ff75.png";